<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <multiselect
          v-model="filters.brand"
          :options="brands"
          selectLabel=""
          selectedLabel=""
          placeholder="Buscar Marca"
        />
      </form-group>

      <form-group :label="$t('department.label')" :columns="6">
        <multiselect
          v-model="filters.department"
          :options="departments"
          selectLabel=""
          selectedLabel=""
          placeholder="Buscar Categorias"
        />
      </form-group>

      <product-status :module="module" @change="onChange"/>

    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'
  import notifier from '@/notifier'
  import ProductStatus from '@/components/tool/batch/shared/filters/marketplace/ProductStatus'
  import { merge } from 'lodash'

  export default {
    data: () => ({
      brands: [],
      departments: [],
      loading: false,
      filters: {
        brand: null,
        department: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      try {
        this.categories = await api.sicredi.getCategories()
        const categoriesformatted = []
        this.categories.forEach(function (unitcategory) {
          categoriesformatted[unitcategory.id] = unitcategory.name
        })
        this.departments = categoriesformatted
      } catch (err) {
        notifier.error('Não foi possível carregar as categorias da Sicredi.', 'Erro')
      }

      try {
        this.brands = await api.sicredi.getBrands()
        const brandsformatted = []
        this.brands.forEach(function (unitBrand) {
          brandsformatted[unitBrand.id] = unitBrand.name
        })
        this.brands = brandsformatted
      } catch (err) {
        notifier.error('Não foi possível carregar as marcas da Sicredi.', 'Erro')
      }
    },
    methods: {
      onChange (filters) {
        this.filters = merge(filters, this.filters)
      }
    },
    components: {
      FormGroup,
      Loader,
      ProductStatus
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Sicredi.vue?6051c206